import { appendDomainQueryParam } from '$lib/utils/appendDomainQueryParam';
import { getDataBaseUrl } from '$lib/utils/getDataBaseUrl';
import { isFunBrandsEnabled } from '$lib/utils/isFunBrandsEnabled';

import debug from 'debug';

import type { PageLoad } from './$types';

const debugLog = debug('routes:+page.js');

export const load: PageLoad = async ({ fetch }) => {
    const dataBasePath = getDataBaseUrl();
    const res = await fetch(
        `${dataBasePath}/indexPage.json?v=${window.campaignVersionId}${appendDomainQueryParam()}`,
    );
    const pageData = await res.json();

    // TODO: Remove once Theming 2.0 is fully migrated
    if (isFunBrandsEnabled(pageData)) {
        pageData.theme = pageData.themeV2;
    }

    debugLog(pageData);

    return pageData;
};
